export * from "./KHR_animation_pointer.data.pure";

import { _RegisterKHRAnimationPointerData } from "./KHR_animation_pointer.data.pure";

_RegisterKHRAnimationPointerData();
